export default {
  search: 'search',
  searchPlaceholder: 'Search for a project, a technology...',
  navigation: 'navigation',
  noResult: 'No result was found'
};
